import Text from 'components/base/Text';
import { LineSkeleton } from 'components/base/Skeletons';

const MAX_ISSUES_LIMIT = 5000;

const IssuesNumberCell = ({ number, isLoading, isError }) => {
  const invalidNumber = number < 0;
  const issuesNumText =
    invalidNumber || isError
      ? 'N/A'
      : number >= MAX_ISSUES_LIMIT
      ? `${MAX_ISSUES_LIMIT}+`
      : number;

  if (isLoading) return <LineSkeleton />;

  return <Text size='medium'>{issuesNumText}</Text>;
};

export default IssuesNumberCell;
